import useSWR from 'swr';
import { ReportColumnData, ReportsService } from '../../api';

const fetcher = async ({ language }: { language: string }): Promise<ReportColumnData[]> =>
  (await ReportsService.getReportColumns(language)).columns;

// The report's columns in file order, each with a stable key. Presets store those keys, so this is
// what maps a saved preset onto the CSV the server hands back — the headers in the file itself are
// localized and can't be matched on.
export const useReportColumns = (language: string) => {
  const { data, error, isLoading } = useSWR({ opId: 'getReportColumns', language }, fetcher);
  return { columns: data ?? [], isLoading, isError: error };
};
